import { IApplyOnline } from "../types/applyOnline";
import { IUserData } from "../types/userAuthTypes";
import { apiType } from "./apiType";
import { saveUserConfigToStorage } from "../utils/userConfigStorage";
import { IUserOptionsConfig } from "../types/userOptions";

export const userAuthRequests = {
  singIn: async (data: Record<string, string | number>) => {
    try {
      const formData = new URLSearchParams();
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, String(value));
      });

      return await apiType.main.post<IUserData>(`/auth/sign-in`, formData.toString(), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
    } catch (error) {
      console.log("ERROR sign-in:", error);
      return null;
    }
  },
  singUp: async (data: object) => {
    try {
      return await apiType.main.post<IUserData>(`/auth/sign-up`, data);
    } catch (error) {
      console.log("ERROR sign-up:", error);
      return null;
    }
  },
  singOut: async () => {
    try {
      return await apiType.main.get(`/auth/sign-out`);
    } catch (error) {
      console.log("ERROR sign-out:", error);
      return null;
    }
  },
  usersList: async () => {
    try {
      return await apiType.main.get(`/users/list`);
    } catch (error) {
      console.log("ERROR sign-out:", error);
      return null;
    }
  },
};

export const userChangeInfoRequest = {
  /**
   * Обновление конфигурации пользователя на бэке
   * @param employeeId - ID сотрудника
   * @param configToSend - Конфигурация для отправки (уже подготовленная, без локальных настроек)
   * @param fullConfig - Полная конфигурация из Redux store для сохранения в localStorage
   */
  userConfigUpdate: async (employeeId: string | number | null, configToSend: object, fullConfig?: Partial<IUserOptionsConfig>) => {
    try {
      const response = await apiType.main.put<IApplyOnline>(`/employee-config/update/${employeeId}`, configToSend);
      // Сохраняем в localStorage полную конфигурацию из Redux store после успешного ответа
      // Это гарантирует синхронизацию localStorage с актуальным состоянием
      if (fullConfig) {
        saveUserConfigToStorage(fullConfig);
      } else {
        // Если fullConfig не передан, сохраняем то, что отправили (для обратной совместимости)
        saveUserConfigToStorage(configToSend as Partial<IUserOptionsConfig>);
      }
      console.log("Успешное сохранение конфигурации", response);
      return response;
    } catch (error) {
      console.error("Ошибка при обновлении конфигурации:", error);
      // Не сохраняем в localStorage при ошибке
      // Выбрасываем ошибку для обработки на уровне выше
      throw error;
    }
  },
  userInfoUpdate: async (userId: string | null, data: object) => {
    try {
      const response = await apiType.main.put<IApplyOnline>(`/users/update/${userId}`, data);
      console.log("Успешный успех", response);
      return response;
    } catch (error) {
      console.log("Это ошибка при create:", error);
    }
  },
};
